import apiClient from './apiClient';

export interface QueryParams {
  dateFrom?: string;
  dateTo?: string;
  empFrom?: string;
  empTo?: string;
  leaveType?: string;
  deptFrom?: string;
  deptTo?: string;
}

export interface LeaveRow {
  doc_no: string;
  emp_no: string;
  emp_name: string;
  dept_code: string;
  dept_name: string;
  leave_type: string;
  leave_date: string;
  start_time: string;
  end_date: string;
  end_time: string;
  unit: string;
  duration: number;
  reason: string;
}

export interface QueryResponse {
  data: LeaveRow[];
  count: number;
  total_day: number;
  message?: string;
}

export const pw9321Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9321/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9321/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
